// extracted by mini-css-extract-plugin
export default {"root":"Pcnw5i1YJs"};